export default {
	// id-ID.js
	security: {
		securityBind: "Ikatan Keamanan",
		securitySettings: "Pengaturan Keamanan",
		level: "Sedang",
		confirm: "Konfirmasi",
		submitting: "Mengirim...",
		add: "Tambah",
		change: "Ubah",
		success: "Berhasil diperbarui",
		select: "Pilih",

		birthday: "Tanggal Lahir Kontak",
		birthdayDesc: "Tambahkan tanggal lahir kontak agar komunikasi lebih mudah. Informasi pribadi Anda akan tetap terlindungi.",
		month: "Bulan",
		day: "Hari",
		year: "Tahun",
		birthdayRequired: "Tanggal lahir wajib diisi.",
		invalidBirthday: "Tanggal lahir tidak valid.",
		invalidMonth: "Bulan tidak valid.",
		invalidDay: "Hari tidak valid.",
		invalidYear: "Tahun tidak valid.",
		updateBirthdayFail: "Gagal memperbarui tanggal lahir",
		birthdayVerify: "Verifikasi ikatan tanggal lahir",
		birthdayVerifyDesc: "Tambahkan tanggal lahir Anda untuk meningkatkan keamanan akun.",

		email: "Email Kontak",
		emailDesc: "Email untuk keamanan akun. Hanya Anda yang dapat menautkannya.",
		emailRequired: "Email wajib diisi.",
		emailInvalid: "Alamat email salah.",
		updateEmailFail: "Gagal memperbarui email",
		emailVerify: "Verifikasi ikatan email",
		emailVerifyDesc: "Verifikasi alamat email Anda untuk meningkatkan keamanan akun.",

		phone: "Nomor Telepon",
		bindPhone: "Tautkan Nomor Telepon",
		phoneDesc: "Nomor telepon untuk keamanan akun. Hanya Anda yang dapat menautkannya.",
		phoneRequired: "Nomor telepon wajib diisi.",
		phoneUsed: "Silakan gunakan nomor telepon yang berbeda.",
		updatePhoneFail: "Gagal memperbarui nomor telepon",
		noCode: "Belum menerima kode?",
		smsHelp: "Jika Anda sudah mencoba beberapa kali tetapi masih belum menerima kode verifikasi.",
		smsTips1: "1. Periksa apakah nomor ponsel yang Anda masukkan sudah benar.",
		smsTips2: "2. Periksa apakah nomor ponsel Anda sudah tidak aktif.",
		smsTips3: "3. Periksa apakah pesan masuk ke kotak SMS.",
		smsTips4: "4. Pesan mungkin terlambat beberapa menit.",
		phoneVerify: "Verifikasi ikatan nomor telepon",
		phoneVerifyDesc: "Verifikasi nomor telepon Anda untuk meningkatkan keamanan akun.",

		setPassword: "Atur Kata Sandi",
		passwordDesc: "Atur kata sandi masuk Anda.",
		clickSelectBirthday: "Klik untuk memilih hari ulang tahun",
		selectBirthday: "Pilih Hari Ulang Tahun",
		confirm: "Konfirmasi",
		cancel: "Batal",
		withdrawPassword: "Kata Sandi Penarikan",
		withdrawpasswordDesc: "Atur kata sandi penarikan uang Anda.",
		set: "Atur",
	},
	contactPhone: {
		title: "Ubah Nomor Telepon",
		titleMobile: "Ubah",
		description: "Tambahkan nomor telepon kontak untuk komunikasi yang lebih mudah. Informasi pribadi Anda akan tetap terlindungi.",
		label: "Nomor Telepon Kontak",
		confirm: "Konfirmasi",
		submitting: "Mengirim...",
		required: "Nomor telepon wajib diisi",
		invalid: "Nomor telepon tidak valid",
		success: "Nomor telepon berhasil diperbarui!",
		updateFailed: "Gagal memperbarui",
		tryAgain: "Gagal memperbarui, silakan coba lagi nanti",
		verifyTitleMobile: "Verifikasi Telepon",
		titleMobile: "Tautkan Telepon",
		changeTitleMobile: "Ubah Telepon",
		securityTip: "Telepon untuk keamanan akun. Hanya Anda yang dapat menautkannya.",
		placeholder: "Nomor Telepon",
		noCodeReceived: "Tidak menerima kode?",
		codeDescription: "Masukkan 6 digit kode verifikasi yang dikirim ke detail kontak Anda di bawah ini:",
		resendIn: "Kirim ulang dalam {countdown} dtk",
		resend: "Kirim ulang",
		submitting: "Mengirimkan...",
		confirm: "Konfirmasi",
		invalidCode: "Silakan masukkan 6 digit kode yang valid",
		required: "Nomor telepon wajib diisi",
		invalid: "Silakan masukkan nomor telepon yang valid",
		success: "Berhasil diperbarui",
		updateFailed: "Gagal memperbarui",
		tryAgain: "Silakan coba lagi nanti"
	},

	contactEmail: {
		title: "Ubah Email",
		titleMobile: "Ubah",
		description: "Tambahkan email kontak untuk komunikasi yang lebih mudah. Informasi pribadi Anda akan tetap terlindungi.",
		label: "Email Kontak",
		placeholder: "Email",
		confirm: "Konfirmasi",
		submitting: "Mengirim...",
		required: "Email tidak boleh kosong",
		invalid: "Silakan masukkan alamat email yang valid",
		success: "Email berhasil diperbarui!",
		updateFailed: "Gagal memperbarui",
		tryAgain: "Gagal memperbarui, silakan coba lagi nanti",
		verifyTitleMobile: "Verifikasi Email",
		titleMobile: "Tautkan Email",
		changeTitleMobile: "Ubah Email",
		securityTip: "Email untuk keamanan akun. Hanya Anda yang dapat menautkannya.",
		noCodeReceived: "Tidak menerima kode?",
		codeDescription: "Masukkan 6 digit kode verifikasi yang dikirim ke detail kontak Anda di bawah ini:",
		resendIn: "Kirim ulang dalam {countdown} dtk",
		resend: "Kirim ulang",
		submitting: "Mengirimkan...",
		confirm: "Konfirmasi",
		invalidCode: "Silakan masukkan 6 digit kode yang valid",
		required: "Email wajib diisi",
		invalid: "Silakan masukkan alamat email yang valid",
		success: "Berhasil diperbarui",
		updateFailed: "Gagal memperbarui",
		tryAgain: "Silakan coba lagi nanti"
	},

	accountInfo: {
		profileInfo: "Info Profil",
		contactInfo: "Info Kontak",
		privacy: "Privasi",
		contactEmail: "Email Kontak",
		contactPhone: "Nomor Telepon Kontak",
		addEmailDesc: "Tambahkan email kontak untuk komunikasi yang lebih mudah. Informasi pribadi Anda akan tetap terlindungi.",
		addPhoneDesc: "Tambahkan nomor telepon kontak untuk komunikasi yang lebih mudah. Informasi pribadi Anda akan tetap terlindungi.",
		hideUsername: "Sembunyikan nama pengguna saya dari daftar publik",
		add: "Tambah",
		change: "Ubah",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "PEMAIN",
		copied: "Disalin!",
		hideSuccess: "Nama pengguna berhasil disembunyikan",
		showSuccess: "Nama pengguna berhasil ditampilkan",
		operationFailed: "Operasi gagal",
		editProfile: "Edit Profil",
		  contactInfo: "Info Kontak",
		  contactEmail: "Email Kontak",
		  emailTip: "Tambahkan email kontak untuk komunikasi yang lebih mudah. Informasi pribadi Anda akan tetap dilindungi.",
		  change: "Ubah",
		  addEmail: "Tambah Email",
		  contactPhone: "Nomor Telepon Kontak",
		  phoneTip: "Tambahkan nomor telepon Anda untuk verifikasi akun yang aman.",
		  addPhone: "Tambah Nomor Telepon",
		  birthdayBind: "Verifikasi pengikatan ulang tahun",
		  birthdayTip: "Ikat ulang tahun Anda untuk meningkatkan keamanan akun Anda.",
		  addBirthday: "Tambah Hari Ulang Tahun",
		  personalInfo: "Info Pribadi",
		  personalTip: "Verifikasi identitas Anda untuk membuka lebih banyak layanan. Data Anda aman.",
		  verifyNow: "Verifikasi Sekarang",
		  hideUsernameTip: "Jika diaktifkan, pengguna lain tidak akan dapat melihat nama pengguna Anda di daftar publik.",
	},

	kyc: {
		title: "Verifikasi Identitas",
		verifyIdentity: "Verifikasi identitas Anda",
		completeDesc: "Selesaikan verifikasi identitas untuk menjaga keamanan akun dan membuka semua fitur.",
		failed: "Verifikasi gagal. Silakan coba lagi.",
		reVerify: "Verifikasi ulang",
		checkYouOut: "Mari verifikasi identitas Anda",
		prepareDoc: "Siapkan dokumen Anda",
		prepareDocDesc: "Siapkan dokumen identitas yang valid.",
		useSmartphone: "Gunakan smartphone",
		useSmartphoneDesc: "Anda memerlukan smartphone untuk menyelesaikan verifikasi.",
		scanQr: "Pindai kode QR",
		scanQrDesc: "Pindai kode QR dengan ponsel Anda untuk melanjutkan di perangkat seluler.",
		noSmartphone: "Tidak punya smartphone?",
		completeOnMobile: "Selesaikan di ponsel"
	},

	verify: {
		title: "Verifikasi",
		personalVerification: "Verifikasi Pribadi",
		weak: "Lemah",
		level1: "Level 1",
		personalInfo: "Informasi Pribadi",
		personalInfoDesc: "Lengkapi informasi pribadi Anda untuk meningkatkan keamanan akun.",
		verifyNow: "Verifikasi Sekarang",
		level2: "Level 2",
		kycVerification: "Verifikasi KYC",
		kycDesc: "Selesaikan verifikasi KYC untuk membuka limit lebih tinggi dan akses penuh.",
		docTip: "Pastikan dokumen Anda jelas dan valid sebelum mengirim."
	},

	personalInfo: {
		verify: "Verifikasi",
		completeInfo: "Lengkapi Informasi Anda",
		completeInfoDesc: "Isi data pribadi Anda untuk menyelesaikan verifikasi.",
		firstName: "Nama Depan",
		paternalSurname: "Nama Belakang Ayah",
		maternalSurname: "Nama Belakang Ibu",
		contactNumber: "Nomor Kontak",
		phoneUsed: "Nomor telepon ini sudah digunakan.",
		contactEmail: "Email Kontak",
		invalidEmail: "Alamat email tidak valid.",
		detailedAddress: "Alamat Lengkap",
		city: "Kota",
		street: "Jalan",
		neighborhood: "Lingkungan",
		houseNumber: "Nomor Rumah",
		postalCode: "Kode Pos",
		save: "Simpan",
		male: "Laki-laki",
		female: "Perempuan"
	},

	withdrawPassword: {
		changeTitle: "Ubah Kata Sandi Penarikan",
		setTitle: "Atur Kata Sandi Penarikan",
		changeDesc: "Masukkan kata sandi lama Anda dan atur kata sandi penarikan baru.",
		setDesc: "Atur kata sandi penarikan untuk melindungi dana Anda.",
		oldPlaceholder: "Kata Sandi Penarikan Lama",
		newPlaceholder: "Kata Sandi Penarikan Baru",
		confirmPlaceholder: "Konfirmasi Kata Sandi Penarikan"
	},

	contactBirthday: {
		title: "Tanggal Lahir Kontak",
		desc: "Tambahkan tanggal lahir kontak agar komunikasi lebih mudah. Informasi pribadi Anda akan tetap terlindungi.",
		label: "Tanggal Lahir Kontak",
		invalid: "Tanggal lahir tidak valid."
	},

	changePassword: {
		title: "Ubah Kata Sandi",
		expiredDesc: "Kata sandi Anda telah kedaluwarsa. Silakan atur kata sandi baru untuk melanjutkan.",
		verifyOldDesc: "Masukkan kata sandi lama Anda dan atur yang baru.",
		passwordPlaceholder: "Kata Sandi Lama",
		newPlaceholder: "Kata Sandi Baru",
		confirmPlaceholder: "Konfirmasi Kata Sandi Baru",
		lengthError: "Kata sandi harus terdiri dari 6 hingga 30 karakter.",
		sameAsOld: "Kata sandi baru tidak boleh sama dengan yang lama.",
		confirmRequired: "Silakan konfirmasi kata sandi baru Anda.",
		notMatch: "Kata sandi tidak cocok.",
		success: "Kata sandi berhasil diubah",
		failed: "Gagal mengubah kata sandi"
	},

	settingsNav: {
		title: "Pengaturan",
		accountInfo: "Info Akun",
		security: "Keamanan"
	},

	verificationBirthday: {
		title: "Hari Ulang Tahun",
		securityTip: "Tanggal lahir untuk keamanan akun. Hanya Anda yang dapat menautkannya.",
		clickSelectBirthday: "Klik untuk memilih tanggal lahir",
		invalidBirthday: "Tanggal lahir tidak valid",
		submitting: "Mengirimkan...",
		confirm: "Konfirmasi",
		cancel: "Batal",
		selectBirthday: "Pilih Tanggal Lahir",
		birthdayRequired: "Tanggal lahir wajib diisi",
		updateBirthdayFail: "Gagal memperbarui tanggal lahir",
		success: "Berhasil diperbarui"
	}
};